import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getTeamById } from "../../../../../../store/selectors/selector.teams.jsx";
import { HeaderNameMenu } from "../../HeaderNameMenu.jsx";

export const Team = ({ id }) => {
  const team = useSelector((state) => getTeamById(state, id));

  return (
    <div className="tw-flex tw-items-center tw-min-w-0">
      <HeaderNameMenu name={team.name} />
    </div>
  );
};

Team.propTypes = {
  id: PropTypes.number.isRequired,
};
